import { Form } from 'antd';

export function useIsCatering() {
  const form = Form.useFormInstance();
  const merchant = form.getFieldValue('merchant');

  return merchant?.is_catering;
}
